// extracted by mini-css-extract-plugin
module.exports = {"topic":"Index_topic__1uFYC","count":"Index_count__1j5fv","title":"Index_title__1Utwr","time":"Index_time__1O1q7"};